import { render, staticRenderFns } from "./loglist.vue?vue&type=template&id=2d7ba870&"
import script from "./loglist.vue?vue&type=script&lang=js&"
export * from "./loglist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports